import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { selectCompletedOrderServiceId } from 'reducers/root';
import OrderNumber from 'components/Pages/ThankYou/orderNumber';
import messages from 'components/Pages/ThankYou/messages';
import { getServiceOrderConfirmationMessage } from 'selectors/root';
import { CustomConfirmationMessage } from '../styles';
import { getCompletedOrderEmail } from '../../../../selectors/order';

const ThankYouHeaderMessage = ({ orderNumber, userEmail, orderConfirmationMessage }) => (
  <>
    <p>
      <FormattedMessage {...messages.thankYouHeader} />
    </p>
    {orderNumber && (
      <p>
        {userEmail ? (
          <FormattedMessage
            {...messages.orderConfirmationMessage}
            values={{
              orderNumber: <OrderNumber number={orderNumber} />,
              email: <strong>{userEmail}</strong>,
            }}
          />
        ) : (
          <FormattedMessage
            {...messages.orderConfirmationMessageWithoutEmail}
            values={{
              orderNumber: <OrderNumber number={orderNumber} />,
            }}
          />
        )}
      </p>
    )}
    {orderConfirmationMessage && (
      <CustomConfirmationMessage> {orderConfirmationMessage} </CustomConfirmationMessage>
    )}
  </>
);

ThankYouHeaderMessage.propTypes = {
  orderNumber: PropTypes.string,
  userEmail: PropTypes.string,
  orderConfirmationMessage: PropTypes.string,
};

const mapStateToProps = state => {
  const serviceId = selectCompletedOrderServiceId(state) && selectCompletedOrderServiceId(state).toString();
  return {
    userEmail: getCompletedOrderEmail(state),
    orderConfirmationMessage: getServiceOrderConfirmationMessage(state, serviceId),
  };
};

export default connect(mapStateToProps)(ThankYouHeaderMessage);
